import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as redux from "redux";
import { Paths } from "../../constants";
import * as M from "../../models";
import { AppState } from "../../store";
import { Utility } from "../../utils";
import Settings from "../../settings";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    user: state.auth.data && state.auth.data.hasUserRecord
        ? state.auth.data
        : undefined,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
}

interface ConnectedState {
    user?: M.Auth.AuthTokenData;
}

interface ConnectedDispatch {
}

interface OwnState {
}

class UtilityMenuComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {
    public render() {
        const user = this.props.user;

        const itemUserFullName = user
            ? <li><Link className="nav-highlight" to={Paths.User.Account}>{Utility.joinSkipEmpty([user.userFirstName, user.userLastName], " ")}</Link></li>
            : null;

        const itemSignOut = user
            ? <li><Link to={Paths.Account.Logout}>Sign out</Link></li>
            : null;

        const itemJoin = user
            ? null
            : <li><a href={Settings.AsrsLegacyUrl + "/join-asrs"}>Join the ASRS</a></li>;

        const itemSignIn = user
            ? null
            : <li><a className="nav-highlight" href="https://www.asrs.org/members/login?returnUrl=BetaASRSSSO">Sign in</a></li>;

        return <div id="member-nav">
                <ul>
                    <li><a href={Settings.AsrsLegacyUrl + "/about/contact-us"}>Contact us</a></li>
                    {itemUserFullName}
                    {itemSignOut}
                    {itemJoin}
                    {itemSignIn}
                </ul>
            </div>;
    }
}

export const UtilityMenu: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(UtilityMenuComponent);



// WEBPACK FOOTER //
// ./src/components/layout/UtilityMenu.tsx